import React, { useEffect } from "react";
import { NextPage, NextPageContext } from "next";
import { useRouter } from "next/router";
import Image from "next/image";
import * as Sentry from "@sentry/nextjs";
import { useSession } from "next-auth/react";
import { TYPO } from "styles/Typo";
import Button from "components/common/buttons/buttons";

interface ErrorProps {
  statusCode?: number | null;
}

const Error404 = ({ isMobile }: { isMobile: boolean }) => {
  const router = useRouter();
  if (isMobile) {
    return (
      <main
        className="min-w-[360px] flex flex-col  items-center justify-center "
        style={{
          height: "calc(100dvh - 64px)",
        }}
      >
        <p className={`${TYPO.TYPO4_SB} text-gray90 mb-1`}>
          페이지를 찾지 못했어요
        </p>
        <p className={`${TYPO.TYPO7_RG} text-gray50  mb-5`}>
          페이지 주소가 정확한지 확인해주세요
        </p>
        <div className={"flex justify-center items-center"}>
          <Button
            type="primary"
            size="lg"
            text="홈으로 가기"
            clickHandler={() => {
              router.push("/");
            }}
          />
        </div>
      </main>
    );
  }

  return (
    <main
      className="min-w-[1024px] text-center flex flex-col  items-center justify-center  "
      style={{
        height: "calc(100dvh - 64px)",
      }}
    >
      <p className={`${TYPO.TYPO4_SB} text-gray90 mb-1`}>
        페이지를 찾지 못했어요
      </p>
      <p className={`${TYPO.TYPO7_RG} text-gray50  mb-5`}>
        페이지 주소가 정확한지 확인해주세요
      </p>
      <div className={"flex justify-center items-center"}>
        <Button
          type="primary"
          size="lg"
          text="홈으로 가기"
          clickHandler={() => {
            router.push("/");
          }}
        />
      </div>
    </main>
  );
};

export default Error404;
